// single add to cart
$('body').on('click', 'span.fbtx-link', function () {

    var singlevarID = parseInt($(this).parents('.fbtx-product').attr('data-id'));

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            id: singlevarID,
            quantity: 1
        },
        success: function () {

            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {

                    // Update cart bubble count
                    
if (cart.item_count > 0) {
    
            $('header .cart-bubble[ref="cartBubble"]').removeClass('visually-hidden');
       $('span.cart-bubble__text-count').removeClass('hidden');
       $('dialog.cart-drawer__dialog').removeClass('cart-drawer--empty');
      
        } else {
            $('header .cart-bubble[ref="cartBubble"]').addClass('visually-hidden');
       $('span.cart-bubble__text-count').addClass('hidden');
        $('dialog.cart-drawer__dialog').addClass('cart-drawer--empty');
        }
                    // Refresh cart drawer HTML
                    fetch(window.location.href)
                        .then(res => res.text())
                        .then(html => {

                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, 'text/html');

                            const newCart = doc.querySelector('cart-items-component');
                            const oldCart = document.querySelector('cart-items-component');

                            if (newCart && oldCart) {
                                oldCart.replaceWith(newCart);
                            }

                            
                             //document.querySelector('[data-testid="cart-drawer-trigger"]').click();
                        });
$('[ref="cartBubbleCount"]').text(cart.item_count);
                    $('[ref="cartItemCount"]').text(cart.item_count);
                });
setTimeout(function () {
    document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
}, 100);
        },
        error: function (xhr) {
            console.log(xhr.responseText);
        }
    });

});

// bundle add to cart
$('body').on('click', '.fbtx-wrapper button.fbtx-button', function () {
  var json_obj = [];
    $('.fbtx-products .fbtx-product').each(function () {
        var variantID = $(this).attr('data-id');
        console.log(variantID);
          var item = {};
      item["id"] = variantID;
      item["quantity"] = 1;
      json_obj.push(item);
    });
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      items: json_obj,
    },
    dataType: "json",
  success: function () {

            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {

                    // Update cart bubble count
                    $('[ref="cartBubbleCount"]').text(cart.item_count);
                    $('[ref="cartItemCount"]').text(cart.item_count);
   if (cart.item_count > 0) {
    
            $('header .cart-bubble[ref="cartBubble"]').removeClass('visually-hidden');
       $('span.cart-bubble__text-count').removeClass('hidden');
       $('dialog.cart-drawer__dialog').removeClass('cart-drawer--empty');
      
        } else {
            $('header .cart-bubble[ref="cartBubble"]').addClass('visually-hidden');
       $('span.cart-bubble__text-count').addClass('hidden');
        $('dialog.cart-drawer__dialog').addClass('cart-drawer--empty');
        }
                    // Refresh cart drawer HTML
                    fetch(window.location.href)
                        .then(res => res.text())
                        .then(html => {

                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, 'text/html');

                            const newCart = doc.querySelector('cart-items-component');
                            const oldCart = document.querySelector('cart-items-component');

                            if (newCart && oldCart) {
                                oldCart.replaceWith(newCart);
                            }

                            
                            // document.querySelector('[data-testid="cart-drawer-trigger"]').click();
                        });

                });

                setTimeout(function () {
    document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
}, 100);
        },
  });
});




// bundle section hotspot
$(document).ready(function () {

    $('.bundle-wrapper').each(function () {
        var $bundle = $(this);

        function activateBundleHotspot(id) {
            $bundle.find('.fbtx-product').css('opacity', 1).removeClass('is-active');
            $bundle.find('.fbtx-hotspot').removeClass('is-active');
            $bundle.find('.fbtx-hotspot .fbtx-popup').hide();

            $bundle.find('.fbtx-product[data-id="' + id + '"]').css('opacity', 1).addClass('is-active');
            $bundle.find('.fbtx-hotspot[data-id="' + id + '"]').addClass('is-active').find('.fbtx-popup').show();
        }

        var $firstProduct = $bundle.find('.fbtx-products .fbtx-product').first();

        $bundle.find('.fbtx-product').css('opacity', 1);
        $bundle.find('.fbtx-hotspot .fbtx-popup').hide();

        if ($firstProduct.length) {
            activateBundleHotspot($firstProduct.data('id'));
        }

        $bundle.find('.fbtx-product').hover(
            function () {
                activateBundleHotspot($(this).data('id'));
            },
            function () {
                if ($firstProduct.length) {
                    activateBundleHotspot($firstProduct.data('id'));
                }
            }
        );
    });

});




// $('body').on('click','cart-icon.header-actions__cart-icon',function () {
//     setTimeout(function () {
//     alert(33)
//     applyCartStyles();
// }, 200);
// })



function applyCartStyles() {
$('.cart-actions').css({
    display: "flex",
    flexDirection: "column",
    gap: "0",
    borderTop: "1px solid var(--color-border)",
    borderBottom: "1px solid var(--color-border)",
    paddingTop: "0",
    paddingBottom: "0",
    marginTop: "var(--margin-3xs)"
});
$('.cart-totals__container').css({
    display: "flex",
    flexDirection: "column",
});
$('.cart-totals__icon').css({
    height: "var(--icon-size-xs)",
    width: "var(--icon-size-xs)",
    margin: "0"
});
$('span.cart-totals__item.cart-totals__total').css('padding-top', '20px');
  $(".cart-totals").css("width", "100%");

  $("summary.cart-discount__summary").css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  });

  $("form.cart-discount__form").css({
    display: "flex",
    gap: "var(--padding-md)",
    alignItems: "center",
    height: "100%",
    paddingBlock: "var(--padding-2xs) var(--padding-sm)"
  });

  $(".cart-discount__input").css({
    backgroundColor: "var(--color-input-background)",
    color: "var(--color-input-text)",
    borderWidth: "var(--style-border-width-inputs)",
    borderColor: "var(--color-input-border)",
    borderStyle: "solid",
    borderRadius: "var(--style-border-radius-inputs)",
    padding: "var(--padding-sm) var(--padding-md)",
    height: "100%",
    flexGrow: "1",
    minWidth: "0",
    fontSize: "var(--font-size--sm)"
  });

  $(".cart__ctas .cart__checkout-button").css({
    width: "100%",
    height: "clamp(25px,var(--height-buy-buttons),55px)",
    paddingInline: "var(--padding-4xl)"
  });

  $(".cart-totals__item").css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  });

}

// Initial call
applyCartStyles();

// Watch for DOM changes
const observer = new MutationObserver(function () {
    applyCartStyles();
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

document.addEventListener('click', async function (e) {
  const clearCartButton = e.target.closest('#clear-cart');
  if (!clearCartButton) return;

  // Guard against double-clicks while a request is already in flight
  if (clearCartButton.disabled) return;

  try {
    clearCartButton.disabled = true;

    const response = await fetch(
      `${window.Shopify.routes.root}cart/clear.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to clear cart');
    }

    const { CartUpdateEvent } = await import('@theme/events');
    const cart = await fetch('/cart.js').then((res) => res.json());

    const event = new CartUpdateEvent(cart, 'manual-trigger', {
      itemCount: cart.item_count,
      source: 'clear-cart-refresh',
      sections: {},
    });
    document.dispatchEvent(event);

    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer?.hasAttribute('auto-open')) {
      cartDrawer.open();
    }
  } catch (error) {
    console.error('Error clearing cart:', error);
  } finally {
    // Re-enable in case the drawer re-render didn't replace this exact node,
    // or the request failed and the button is still the one in the DOM.
    clearCartButton.disabled = false;
  }
});

